/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BannedItemBulkCopyDTO interface.
 */
export function instanceOfBannedItemBulkCopyDTO(value) {
    if (!('targetMarketplaces' in value) || value['targetMarketplaces'] === undefined)
        return false;
    return true;
}
export function BannedItemBulkCopyDTOFromJSON(json) {
    return BannedItemBulkCopyDTOFromJSONTyped(json, false);
}
export function BannedItemBulkCopyDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ids': json['ids'] == null ? undefined : json['ids'],
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'targetMarketplaces': json['targetMarketplaces'],
        'search': json['search'] == null ? undefined : json['search'],
    };
}
export function BannedItemBulkCopyDTOToJSON(json) {
    return BannedItemBulkCopyDTOToJSONTyped(json, false);
}
export function BannedItemBulkCopyDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ids': value['ids'],
        'selectAll': value['selectAll'],
        'marketplace': value['marketplace'],
        'targetMarketplaces': value['targetMarketplaces'],
        'search': value['search'],
    };
}
